export default {
  groups (state) {
      return state.groups
    },
    selectedGroup (state) {
        return state.selectedGroup
    },
    getPlaylist: state => (id) => {
      return state.groups.find(item => item.groupDefinitionId == id)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/getters.js